// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6689 ? "b536a0f1" : chunkId) + "." + {"3962":"56bcd343fde8ea1f","5437":"0d314b12d3f76ab8","6258":"db023e76f2c7bfd1","6689":"ccfa7a6c5edfdffa","7852":"7e84132920c120bc"}[chunkId] + ".js";
};